// AUTO-GENERATED by scripts/set-tenant.ts from tenant-config.ts logo filenames. Do not edit.
import type { TenantLogos } from '@/tenants/tenant-logos'
import logoLarge from './logo-large.svg?react'
import logoSmall from './logo-small.svg?react'

const logos: TenantLogos = { logoLarge, logoSmall }
export default logos
